import { useDispatch } from "react-redux";
import { Link } from "react-router-dom"
import { ReactSVG } from "react-svg"
import { SHOW_SIDE_MENU_CONVERSATION } from "../../../redux/action/menu/side/sideType";

const HeaderProfileBtn = () => {
  const dispatch = useDispatch();

  const showSideMenu = () => {
    dispatch({
      type: SHOW_SIDE_MENU_CONVERSATION,
    });
  };
    return (
        <button onClick={showSideMenu} className="header-btn lg:hidden">

            <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/messages.svg`} className="w-[70%] h-[70%]" />

        </button>
    )

}

export default HeaderProfileBtn